module.exports = __webpack_public_path__ + "img/downloadApp.d1533b72.gif";